import React, { useState, createContext, ReactNode, useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AllCount, ApiResponseType, homeGraph, IAllChainNetworkType, IGraphType } from './ContextType';
import { axiosInstance } from '../api';
import axios from 'axios';

type IContext = {
  allCount: AllCount;
  setAllCount: (data:AllCount) => void;
  getAllCountHome: () => void;
  getHomeGrapgh: (chartType:string, chartTime:string) => void;
  homeGraphData: IGraphType[];
  allChainNetwork: IAllChainNetworkType[];
  getBlockAndTransactionsList:(payload: any)=>void;
  tableData: any;
  loading: boolean;
  hrCount: any;
  searchTextValue: any;
  getHrChart: ({chartTime}: {chartTime: string}) => void;
  chainNetwork: string;
  setChainNetwork: any;
  tableBlockData: any;
  globalSearch: ({value, searchType}: {value: string, searchType: string}) => void;
  getTps: () => void;
  getGiniToken: () => void;
  giniTokenData: any;
  getWalletAddressByTransactions:  (payload: any) => void;
  walletTransactions:any;
  walletTransactionTotalCount:number;
  tpsData: any;
};

const HomeContext = createContext<IContext | undefined>(undefined);

export const useDefaultContext = () => {
  const context = useContext(HomeContext);
  if (!context) {
    throw new Error("useTheme must be used within a CustomToastProvider");
  }
  return context;
};

type IContextProviderProps = {
  children: ReactNode;
};

export const HomeContextProvider: React.FC<IContextProviderProps> = ({
  children,
}) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [allCount,setAllCount] = useState<AllCount>({
    blockCount:'',
    transactionsCount:'',
    smartContractCount:''
  })
  const [homeGraphData,setHomeGraphData] = useState<IGraphType[]>([]);
  const [tableData,setTableData]=useState([]);
  const [tableBlockData,setTableBlockData]=useState([]);
  const [allChainNetwork, setAllChainNetwork] = useState<IAllChainNetworkType[]>([]);
  const [searchParams] = useSearchParams();
  const network = searchParams.get('network');
  const [chainNetwork, setChainNetwork] = useState<string>(network ||localStorage.getItem('network') || '');
  const [hrCount, setHrCount] = useState<any>();
  const [searchTextValue, setSearchTextValue] = useState<any>();
  const [tpsData, setTpsData] = useState<any>();
  const [walletTransactions, setWalletTransactions] = useState<any>();
  const [giniTokenData, setGiniTokenData] = useState<any>();
  const [walletTransactionTotalCount, setWalletTransactionTotalCount] = useState(0)

  useEffect(()=>{
    getAllChain()
  },[])

  const getAllCountHome = async (): Promise<ApiResponseType<AllCount>> => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/status`);
      setAllCount({blockCount:response.data.latestBlock,transactionsCount:response.data.txCount,smartContractCount:response.data.chaincodeCount});
      return {
        success: true,
        data: response.data,
        message: response.data.message,
      };
    } catch (e: any) {
      setLoading(false);
      return {
        success: false,
        message: e.response?.data?.message,
      };
    } finally {
      setLoading(false);
    }
  };

  const getBlockAndTransactionsList = async (payload: any): Promise<ApiResponseType<any>> => {
    try {
      setLoading(true);
      const url = `/${payload?.tableType}`;
      const response = await axiosInstance.get(url);
      payload?.tableType==='txList' ? setTableData(response?.data?.rows?.txnsData) : setTableBlockData(response?.data?.data);
     return {
        success: true,
        data: response?.data,
        message: response?.data?.message,
      };
    } catch (e: any) {
      setLoading(false);
      return {
        success: false,
        message: e?.response?.data?.message,
      };
    } finally {
      setLoading(false);
    }
  };

  const getAllChain = async (): Promise<ApiResponseType<any>> => {
    try {
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_ROOT_BASE_URL}/blockchain-networks?permissions=${process.env.REACT_APP_KS_EXPLORER}`);

      setAllChainNetwork(response?.data?.result);
      const chain = response?.data?.result?.find((item: any) => item?.blockchain === 'KALP');
      localStorage.setItem('blockchain', chain?.blockchain);

      if(!chainNetwork) {
        localStorage.setItem('network', network ? network : chain?.network);
        setChainNetwork(chain?.network);
      }
      return {
        success: true,
        data: response.data,
        message: response.data.message,
      };
    } catch (e: any) {
      setLoading(false);
      return {
        success: false,
        message: e.response?.data?.message,
      };
    } finally {
      setLoading(false);
    }
  };

  const getHomeGrapgh = async (chartType:string,chartTime:string): Promise<ApiResponseType<homeGraph>> => {
    try {
      setLoading(true);
      let response;
      if(chartTime==='1') {
         response = await axiosInstance.get(`/metrics/${chartType}ByMinute/1`);
      } else if (chartTime==='30') {
         response = await axiosInstance.get(`/metrics/${chartType}ByHour/1`);
      } else if (chartTime==='7') {
         response = await axiosInstance.get(`/metrics/${chartType}ByDay/7`);
      } else if(chartTime==='31') {
         response = await axiosInstance.get(`/metrics/${chartType}ByDay/30`);
      } else {
         response = await axiosInstance.get(`/metrics/${chartType}ByMonth/12`);
      }

      setHomeGraphData(response?.data?.rows ? response?.data?.rows : response?.data.records);
      setHrCount(response?.data?.totalcount || 0)

      return {
        success: true,
        data: response.data,
        message: response.data.message,
      };
    } catch (e: any) {
      setLoading(false);
      return {
        success: false,
        message: e.response?.data?.message,
      };
    } finally {
      setLoading(false);
    }
  };

  const getHrChart = async ({chartTime}: {chartTime: string}): Promise<ApiResponseType<any>> => {
    try {
      setLoading(true);
      // const response = await axiosInstance.get(`auth/kalp/metrics/summary?range=${chartTime}`);
      // setHrCount(response?.data)
      return {
        success: true,
        data:0,
        message: '',
      };
    } catch (e: any) {
      setLoading(false);
      return {
        success: false,
        message: e?.response?.data?.message,
      };
    } finally {
      setLoading(false);
    }
  };

  const globalSearch = async ({value: searchText, searchType}: {value: string, searchType: string}): Promise<ApiResponseType<any>> => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/search?q=${searchText}&searchType=${searchType}`);
      setSearchTextValue(response?.data);
      return {
        success: true,
        data: response?.data,
        message: response?.data?.message,
      };
    } catch (e: any) {
      setLoading(false);
      return {
        success: false,
        message: e?.response?.data?.message,
      };
    } finally {
      setLoading(false);
    }
  };


  const getWalletAddressByTransactions = async (payload: any): Promise<ApiResponseType<any>> => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/search?q=${payload.searchText}&searchType=${payload.searchType}&page=${payload?.PageNumber}&size=${payload?.Size}`);
      setWalletTransactions(response?.data?.data);
      setWalletTransactionTotalCount(response.data.noOfPages || 0)
      return {
        success: true,
        data: response?.data,
        message: response?.data?.message,
      };
    } catch (e: any) {
      setLoading(false);
      return {
        success: false,
        message: e?.response?.data?.message,
      };
    } finally {
      setLoading(false);
    }
  };

  const getTps = async (): Promise<ApiResponseType<any>> => {
    try {
      setLoading(true);
       const response = await axiosInstance.get(`/metrics/transactions/lastMinute`);
      setTpsData(response?.data);
      return {
        success: true,
        data: response.data,
        message: response.data.message,
      };
    } catch (e: any) {
      setLoading(false);
      return {
        success: false,
        message: e.response?.data?.message,
      };
    } finally {
      setLoading(false);
    }
  };

  const getGiniToken = async (): Promise<ApiResponseType<any>> => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/metrics/token`);
      setGiniTokenData(response?.data);
      return {
        success: true,
        data: response.data,
        message: response.data.message,
      };
    } catch (e: any) {
      setLoading(false);
      return {
        success: false,
        message: e.response?.data?.message,
      };
    } finally {
      setLoading(false);
    }
  };

  const contextValue = {
    loading,
    allChainNetwork,
    allCount,
    setAllCount,
    getAllCountHome,
    getHomeGrapgh,
    homeGraphData,
    getBlockAndTransactionsList,
    tableData,
    getHrChart,
    globalSearch,
    hrCount,
    searchTextValue,
    setChainNetwork,
    chainNetwork,
    tableBlockData,
    getTps,
    tpsData,
    getWalletAddressByTransactions,
    walletTransactions,
    walletTransactionTotalCount,
    getGiniToken,
    giniTokenData
  };

  return (
    <HomeContext.Provider value={contextValue}>{children}</HomeContext.Provider>
  );
};
